<template>
    <div style="width: 100%; height: 100%">
        <GMapMap
            :center="center"
            :zoom="13"
            map-type-id="roadmap"
            style="width: 100%; height: 100%"
            :options="options"
            ref="gmap"
        >
            <!--
<GMapCircle
v-for="(property, index) in geoinfo.properties" v-bind:key="'circle-'+index"
:radius="Number('300')"
:center="{
lat: Number(property.geoinfo.lat),
lng: Number(property.geoinfo.lng),
}"
:options="circleOptions"
@mouseup.native="openMarker(index)"
/>-->
            <GMapMarker
                v-for="(property, index) in geoinfo.properties"
                v-bind:key="'marker-' + index"
                :position="{
                    lat: Number(property.geoinfo.lat),
                    lng: Number(property.geoinfo.lng),
                }"
                :icon="{
                    url: '',
                    scaledSize: { width: 0, height: 0 },
                    labelOrigin: { x: 0, y: 0 },
                }"
            >
                <GMapInfoWindow
                    :options="infoWindowOptions"
                    :opened="openedMarkerID == null"
                    @click="openMarker(index)"
                >
                    <div class="property-gmaps-holder flex font-semibold leading-normal">
                        <template
                            v-if="
                                property.info.elements.vermarktungsart ==
                                'miete'
                            "
                        >
                            {{
                                $globalFunctions.formatPrice(
                                    property.info.elements.kaltmiete
                                )
                            }}
                            €/mesec
                        </template>
                        <template v-else>
                            {{
                                $globalFunctions.formatPrice(
                                    property.info.elements.kaufpreis
                                )
                            }}
                            €
                        </template>
                    </div>
                </GMapInfoWindow>

                <GMapInfoWindow
                    :options="infoWindowOptions"
                    @closeclick="openMarker(null)"
                    :opened="openedMarkerID == index"
                    :closeclick="true"
                >
                    <div class="property-holder flex">
                        <div class="image-holder">
                            <template v-if="property.info.mapped_images[0]">
                                <img
                                    style="
                                        width: 200px;
                                        margin-left: 5px;
                                        margin-right: 5px;
                                    "
                                    :src="
                                        property.info.mapped_images[0]
                                            .elements[0].url
                                    "
                                />
                            </template>
                        </div>
                        <div class="data-holder flex flex-col justify-between">
                            <div
                                class="line-clamp-2 text-[14px] font-semibold leading-normal"
                            >
                                <a :href="property.url">{{
                                    property.info.elements.objekttitel
                                }}</a>
                            </div>
                            <div
                                class="mb-2 flex items-center text-[12px] leading-none text-black-40"
                            >
                                <v-icon
                                    icon="map-pin"
                                    size="w-[14px] h-[14px]"
                                    class="mr-2 text-black-40"
                                ></v-icon>
                                <span class="line-clamp-1">
                                    <template
                                        v-if="
                                            property.info.elements
                                                .regionaler_zusatz[0]
                                        "
                                    >
                                        {{
                                            locations[
                                                property.info.elements
                                                    .regionaler_zusatz[0]
                                            ]["location"]
                                        }}
                                    </template>
                                </span>
                            </div>
                            <div
                                class="mb-3 flex gap-9 text-[12px] font-medium leading-none"
                            >
                                <div class="flex items-center">
                                    <v-icon
                                        icon="square-size"
                                        class="mr-2"
                                    ></v-icon>
                                    <span class="line-clamp-1">
                                        {{ property.info.elements.wohnflaeche }}
                                        m²
                                    </span>
                                </div>
                                <div class="flex items-center">
                                    <v-icon icon="rooms" class="mr-2"></v-icon>
                                    <span class="line-clamp-1">
                                        {{
                                            Number(
                                                property.info.elements
                                                    .anzahl_zimmer
                                            )
                                        }}-sobno
                                    </span>
                                </div>
                            </div>
                            <div class="text-heading-4-bold text-green-49">
                                <template
                                    v-if="
                                        property.info.elements
                                            .vermarktungsart == 'miete'
                                    "
                                >
                                    <span class="text-green">
                                        {{
                                            $globalFunctions.formatPrice(
                                                property.info.elements.kaltmiete
                                            )
                                        }}
                                    </span>
                                    €/mesec
                                </template>
                                <template v-else>
                                    <span class="text-green">
                                        {{
                                            $globalFunctions.formatPrice(
                                                property.info.elements.kaufpreis
                                            )
                                        }}
                                    </span>
                                    €
                                </template>
                            </div>
                        </div>
                    </div>
                </GMapInfoWindow>
            </GMapMarker>
        </GMapMap>
    </div>
</template>

<script>
export default {
    name: "SearchResultsGoogleMaps",

    emits: ["click"],

    props: {
        geoinfo: {
            type: Object,
            required: true,
        },
        locations: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            showInfoWindows: true,
            paths: [],
            center: {
                lat: Number(this.geoinfo.search.lat),
                lng: Number(this.geoinfo.search.lng),
            },
            options: {
                zoomControl: true,
                zoomControlOptions: {},
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: true,
                streetViewControlOptions: {},
                rotateControl: false,
                fullscreenControl: false,
                disableDefaultUi: false,
                gestureHandling: "cooperative",
            },
            circleOptions: {
                strokeColor: "#FF0000",
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: "#FF0000",
                fillOpacity: 0.35,
            },
            infoWindowOptions: {
                pixelOffset: {
                    width: 0,
                    height: 0,
                },
                //maxWidth: 320,
                //maxHeight: 320,
            },
            openedMarkerID: null,
        };
    },
    mounted() {
        // We have to wait for the map to load, before we can access google.maps...
        this.$refs.gmap.$mapPromise.then((map) => {
            this.options.streetViewControlOptions.position = google.maps.ControlPosition.RIGHT_CENTER;
            this.options.zoomControlOptions.position = google.maps.ControlPosition.RIGHT_CENTER;
        });
    },
    computed: {},
    methods: {
        openMarker(id) {
            this.openedMarkerID = id;
        },
    },
};
</script>
